export const livePageTestIDs = {
  livePage: 'live_page',
  header: 'live_page_header',
  contextDrawerTile: 'context_drawer_tile',
  contextDrawerSpanishTile: 'context_drawer_spanish_tile',
  contextDrawerPattrnTile: 'context_drawer_pattrn_tile',
};
